import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
	{
		path: '/layer-scoper/',
		name: 'index',
		redirect: '/layer-scoper/home',
		component: r => require.ensure([], () => r(require('@/pages/HomePage')), 'HomePage')
	},
	{
		path: '/layer-scoper/home',
		name: 'home',
		component: r => require.ensure([], () => r(require('@/pages/HomePage')), 'HomePage')
	},
	{
		path: '/layer-scoper/start/install',
		name: 'install',
		component: r => require.ensure([], () => r(require('@/pages/InstallPage')), 'InstallPage')
	},
	{
		path: '/layer-scoper/start/update',
		name: 'update',
		component: r => require.ensure([], () => r(require('@/pages/UpdatePage')), 'UpdatePage')
	},
	{
		path: '/layer-scoper/idea/layer',
		name: 'layer',
		component: r => require.ensure([], () => r(require('@/pages/LayerPage')), 'LayerPage')
	},
	{
		path: '/layer-scoper/idea/scope',
		name: 'scope',
		component: r => require.ensure([], () => r(require('@/pages/ScopePage')), 'ScopePage')
	},
	{
		path: '/layer-scoper/idea/boundary',
		name: 'boundary',
		component: r => require.ensure([], () => r(require('@/pages/BoundaryPage')), 'BoundaryPage')
	},
	{
		path: '/layer-scoper/use/init',
		name: 'init',
		component: r => require.ensure([], () => r(require('@/pages/InitPage')), 'InitPage')
	},
	{
		path: '/layer-scoper/use/layerscroll',
		name: 'layerscroll',
		component: r => require.ensure([], () => r(require('@/pages/ScrollPage')), 'ScrollPage')
	},
	{
		path: '/layer-scoper/use/eventbind',
		name: 'eventbind',
		component: r => require.ensure([], () => r(require('@/pages/EventBindPage')), 'EventBindPage')
	},
	{
		path: '/layer-scoper/use/databind',
		name: 'databind',
		component: r => require.ensure([], () => r(require('@/pages/DataBindPage')), 'DataBindPage')
	},
	{
		path: '/layer-scoper/use/callback',
		name: 'callback',
		component: r => require.ensure([], () => r(require('@/pages/CallbackPage')), 'CallbackPage')
	},
	{
		path: '/layer-scoper/use/customcallback',
		name: 'customcallback',
		component: r => require.ensure([], () => r(require('@/pages/CustomCallbackPage')), 'CustomCallbackPage')
	},
	{
		path: '/layer-scoper/use/animation',
		name: 'animation',
		component: r => require.ensure([], () => r(require('@/pages/AnimationPage')), 'AnimationPage')
	},
	{
		path: '/layer-scoper/use/scale',
		name: 'scale',
		component: r => require.ensure([], () => r(require('@/pages/ScalePage')), 'ScalePage')
	},
	{
		path: '/layer-scoper/api/initcontroller',
		name: 'initcontroller',
		component: r => require.ensure([], () => r(require('@/pages/InitControllerPage')), 'InitControllerPage')
	},
	{
		path: '/layer-scoper/api/addnewlayer',
		name: 'addnewlayer',
		component: r => require.ensure([], () => r(require('@/pages/AddNewControllerPage')), 'AddNewControllerPage')
	},
	{
		path: '/layer-scoper/api/update',
		name: 'updateapi',
		component: r => require.ensure([], () => r(require('@/pages/UpdateDataPage')), 'UpdateDataPage')
	},
	{
		path: '/layer-scoper/api/wakeup',
		name: 'wakeup',
		component: r => require.ensure([], () => r(require('@/pages/WakeUpPage')), 'WakeUpPage')
	},
	{
		path: '/layer-scoper/api/gotofocus',
		name: 'gotofocus',
		component: r => require.ensure([], () => r(require('@/pages/GoToFocusPage')), 'GoToFocusPage')
	},
	{
		path: '/layer-scoper/api/getlocationinfo',
		name: 'getlocationinfo',
		component: r => require.ensure([], () => r(require('@/pages/GetLocationInfo')), 'GetLocationInfo')
	},
	{
		path: '/layer-scoper/api/setscopeselecteditem',
		name: 'setscopeselecteditem',
		component: r => require.ensure([], () => r(require('@/pages/SetScopeSelectedItem')), 'SetScopeSelectedItem')
	},
	{
		path: '/layer-scoper/api/getscopeselectedinfo',
		name: 'getscopeselectedinfo',
		component: r => require.ensure([], () => r(require('@/pages/GetScopeSelectedInfoPage')), 'GetScopeSelectedInfoPage')
	},
	{
		path: '/layer-scoper/api/scopeselecteditemscrolltomiddle',
		name: 'scopeselecteditemscrolltomiddle',
		component: r => require.ensure([], () => r(require('@/pages/ScopeSelectedItemScrollToMiddlePage')), 'ScopeSelectedItemScrollToMiddlePage')
	},
	{
		path: '/layer-scoper/api/rollingscopeselecteditemclosesttocenter',
		name: 'rollingscopeselecteditemclosesttocenter',
		component: r => require.ensure([], () => r(require('@/pages/RollingScopeSelectedItemClosestToCenterPage')), 'RollingScopeSelectedItemClosestToCenterPage')
	},
	{
		path: '/layer-scoper/plugin/layerscoperscrollview',
		name: 'layerscoperscrollview',
		component: r => require.ensure([], () => r(require('@/pages/LayerScoperScrollViewPage')), 'LayerScoperScrollViewPage')
	},
	{
		path: '/layer-scoper/pluginapi/updatescrollview',
		name: 'updatescrollview',
		component: r => require.ensure([], () => r(require('@/pages/UpdateScrollViewApiPage')), 'UpdateScrollViewApiPage')
	}
]

export default new Router({
  routes,
  mode: 'history',
	strict: process.env.NODE_ENV !== 'production',
});
